// extracted by mini-css-extract-plugin
module.exports = {"counter":"_2t7xA","counterMemberArea":"rCW4z","viewCount":"_3zQB1","commentCount":"_2wfms","replyCount":"_1_KuJ"};